import html2pdf from "html2pdf.js";
import { filesAPI } from "service/apiUrl";
import { serverFiles } from "./utils";

//User Resume pdf
export const getProfileHtmlTemplate = (data, userData) => {
  function createProfileTemplate(data) {
    return `
    <div class="profileContainer" style="width: 900px; height: 150px; display: flex; justify-content: space-between; align-items: flex-end;">
      <div class="profile" style="display: flex; gap: 16px; align-items: center;">
        <img alt="profilepic" src="${serverFiles(data?.profileUrl) || ""}" style="width: 99px; height: 99px; border-radius: 50%; border: 1px solid #c8cdf3;">
        <div class="profileText" style="display: flex; flex-direction: column; gap: 11.2px;">
          <p style="font-size: 16px; font-weight: 700; color: #191722;">${data?.firstName || ""
      } ${data?.lastName || ""}</p>
          <p style="font-size: 12px; font-weight: 500; color: #191722;">${data?.email || ""
      }</p>
        </div>
      </div>
    </div>
  `;
  }

  const generateWorkExperienceHTML = (data) => {
    if (!data?.workExperiences?.length) return "";

    const experiencesHTML = data.workExperiences
      .map((wk, index) => {
        // const brandName = wk?.companyName || "";
        const experience = wk?.yearOfExperience || "";
        const description = wk?.designation || "";

        return `
        <div class="contentholder" style="display: flex; column-gap: 128px; row-gap: 32px; flex-wrap: wrap;">
          <div class="dataItem" style="border-left: 1px solid #6570fc;">
            <p style="padding-left: 9.6px; color: #7c8493; font-weight: 400; font-size: 14px;">Year's of Experience</p>
            <p style="padding-left: 9.6px; font-weight: 600; color: #191722; font-size: 14px;">${experience}</p>
          </div>
          <div class="longDataItem" style="border-left: 1px solid #6570fc;">
            <p style="padding-left: 9.6px; color: #7c8493; font-weight: 400; font-size: 14px;">Description</p>
            <p style="padding-left: 9.6px; font-weight: 400; color: #191722; font-size: 14px;">${description}</p>
          </div>
        </div>
        ${index < data.workExperiences.length - 1
            ? '<hr style="border: 1px solid #c8cdf3; width: 800px;">'
            : ""
          }
      `;
      })
      .join("");

    return `
    <div class="personalDetails" style="width: 900px; display: flex; flex-direction: column; gap: 32px;">
      <p style="font-size: 16px; font-weight: 600; color: #000000;">Work Experience</p>
      ${experiencesHTML}
    </div>
  `;
  };

  function genSkillTemplate(data) {
    const chipItems = data?.skills
      .map(
        (skill) => `
    <div class="chipItem-z" style="
        padding: 12px 20px;
        font-weight: 600;
        font-size: 14px;
        border: 1px solid #d6ddeb;
        border-radius: 6px;">
        ${skill}
    </div>`
      )
      .join("");

    const preferenceItems = data?.categories
      .map(
        (category) => `
    <div class="chipItem-z" style="
        padding: 12px 20px;
        font-weight: 600;
        font-size: 14px;
        border: 1px solid #d6ddeb;
        border-radius: 6px;">
        ${category?.name}
    </div>`
      )
      .join("");

    return `
    <div class="chipContainer" style="width: 900px;">
        <p style="color: #191722; font-weight: 600; font-size: 16px;">Skill(s)</p>
        <div class="chipArray" style="margin-top: 32px; display: flex; gap: 20px; flex-wrap: wrap;">
            ${chipItems}
        </div>
    </div>
    <div class="chipContainer" style="width: 900px;">
        <p style="color: #191722; font-weight: 600; font-size: 16px;">Preference</p> 
        <div class="chipArray" style="margin-top: 32px; display: flex; gap: 20px; flex-wrap: wrap;">
            ${preferenceItems}
        </div>
    </div>
    </div>`;
  }

  function generateOtherAchievementsHTML(data) {
    if (!data?.otherActivities || data.otherActivities.length === 0) {
      return "";
    }

    const activitiesText = data.otherActivities.join(", ");

    return `
    <div class="personalDetails" style="width: 900px; display: flex; flex-direction: column; gap: 32px;">
      <div class="contentholder" style="display: flex; column-gap: 128px; row-gap: 32px; flex-wrap: wrap;">
        <div class="extraBold" style="border-left: 1px solid #6570fc;">
          <p style="padding-left: 9.6px; color: #7c8493; font-weight: 400; font-size: 14px;">Other Achievements</p>
          <p style="padding-left: 9.6px; font-weight: 600; color: #191722; font-size: 14px;">${activitiesText}</p>
        </div>
      </div>
    </div>
  `;
  }

  function generateUserDetailHtml(userData) {
    const getValue = (label, value) => {
      return `
      <div class="dataItem" style="width: 180px; border-left: 1px solid #6570fc;">
        <p style="padding-left: 9.6px; color: #7c8493; font-weight: 400; font-size: 14px;">${label}</p>
        <p style="padding-left: 9.6px; font-weight: 600; color: #191722; font-size: 14px;">${value || "N/A"
        }</p>
      </div>
    `;
    };

    const educationStr =
      userData?.educations?.length > 0
        ? userData.educations
          .map((edu) => edu?.degree)
          .filter(Boolean)
          .join(", ")
        : "N/A";
    const industryStr =
      userData?.industry?.length > 0
        ? data?.industry?.map((ind) => ind).join(", ")
        : "N/A";

    return `
    <div class="groupContainer" style="background-color: white; width: 1000px; display: flex; flex-direction: column; align-items: center; gap: 32px; padding-bottom: 32px; padding-top: 32px;">
      <div class="personalDetails" style="width: 900px; display: flex; flex-direction: column; gap: 32px;">
        <div class="contentholder" style="display: flex; column-gap: 128px; row-gap: 32px; flex-wrap: wrap;">
          ${getValue("Mobile Number", userData?.mobileNo)}
          ${getValue("Gender", userData?.gender)}
          ${getValue("State", userData?.state?.name)}
          ${getValue("City", userData?.city?.name)}
          ${getValue("Education", educationStr)}
          ${getValue("Industry", industryStr)}
        </div>
      </div>
    </div>
  `;
  }

  return `<!DOCTYPE html>
    <html lang="en">
    <head>
      <meta charset="UTF-8">
      <title>Document</title>
    </head>
    <body style="display: flex; justify-content: center; align-items: start; transform: scale(0.8); transform-origin: top; margin:20px">
      <section id="pdf-content" style="background-color: #ffffff; border-radius: 12px; display: flex; flex-direction: column; align-items: center; gap: 44px; width: 1000px;">
        ${createProfileTemplate(data)}
        <hr style="border: 1px solid #c8cdf3; width: 900px;">
        ${generateUserDetailHtml(userData)}
        ${generateWorkExperienceHTML(userData)}
        ${genSkillTemplate(userData)}
        ${generateOtherAchievementsHTML(userData)}
      </section>
    </body>
    </html>`;
};

//Payment Receipt pdf
export function generateReceiptHTML(activePlan, formattedDate) {
  return `

      <section style="display: flex; justify-content: center; margin-top: 28px;">
        <div style="width: 420px; background-color:rgb(239, 247, 247); border-radius: 10.5px;">
    
          <!-- Header -->
          <div style="display: flex; justify-content: space-between; width: 350px; margin: 15.2px auto;">
            <p style="text-align: left; font-weight: 600; font-size: 17.5px;">Your Receipt</p>
            <!-- Optional download icon can go here -->
          </div>
    
          <!-- Inner Container -->
          <div style="display: flex; flex-direction: column; gap: 1px; margin: 0 auto; width: 350px; padding: 5px; border: 1px solid #cccccc; border-radius: 12.25px;">
            <div style="padding: 14px 14px;">
              <p style="font-weight: 700; font-size: 21px; line-height: 18.5px;">${activePlan?.name || "Plan Name"
    }</p>
              <p style="font-weight: 400; font-size: 14px; line-height: 18.5px;">Get started with AI for creatives</p>
            </div>
    
            <div style="width: 320px; padding: 14px 14px; display: flex; justify-content: space-between; align-items: center;">
              
              <p style="font-weight: 700; font-size: 21px;">
                ${activePlan?.amount || "0.00"
    }<span style="font-size: 12.25px; font-weight: 400;">/${activePlan?.name || ""
    }</span>
              </p>
            </div>
          </div>
    
          <!-- Transaction Details -->
          <div style="padding: 0px 21px; margin-top: 14px;">
            <p style="font-weight: 700; font-size: 17.5px;">Transaction Details</p>
            <p style="font-size: 14px; font-weight: 500; color: #000000; margin-top: 7px;">Transaction Id : ${activePlan?.transactionId || "N/A"
    }</p>
            <p style="font-size: 14px; font-weight: 500; color: #000000; margin-top: 7px;">Account Name : ${activePlan?.username || "N/A"
    }</p>
            <hr style="margin-top: 21px;" />
          </div>
    
          <!-- Due Section -->
          <div style="height: 168px; width: 420px; display: flex; align-items: center; margin-bottom: 20px;">
            <div style="width: 30px; height: 168px; display: flex; flex-direction: column; align-items: center; justify-content: center;">
              <div style="width: 10px; height: 10px; border-radius: 50%; background-color: #d9d9d9;"></div>
              <div style="height: 84px; width: 2px; background-color: #d9d9d9;"></div>
              <div style="width: 10px; height: 10px; border-radius: 50%; background-color: #d9d9d9;"></div>
            </div>
    
            <div style="width: 349.3px; height: 134.39px; display: flex; flex-direction: column; justify-content: space-between;">
              <div style="width: 342.36px; padding: 1px 14px; display: flex; justify-content: space-between; align-items: center;">
                <p style="font-weight: 400; font-size: 17.5px;">
                  <span style="font-size: 14px;">Due <br /> 15 day free trial end</span>
                </p>
                <p style="font-weight: 700; font-size: 21px;">0.00<span style="font-size: 12.25px; font-weight: 400;">/${activePlan?.name || ""
    }</span></p>
              </div>
              <div style="width: 342.36px; padding: 1px 14px; display: flex; justify-content: space-between; align-items: center;">
                <p style="font-weight: 400; font-size: 17.5px;">
                  <span style="font-size: 14px;">Due till <br /> ${formattedDate || "N/A"
    }</span>
                </p>
                <p style="font-weight: 700; font-size: 21px;">${activePlan?.amount || "0.00"
    }<span style="font-size: 12.25px; font-weight: 400;">/${activePlan?.name || ""
    }</span></p>
              </div>
            </div>
          </div>
        </div>
      </section>
    `;
}

export const downloadPdf = async (
  htmlContent,
  onSuccess,
  onError,
  config = {},
  imgDelay = 2000
) => {
  try {
    const iframe = document.createElement("iframe");
    iframe.style.position = "absolute";
    iframe.style.left = "-9999px";
    iframe.style.border = "none";
    document.body.appendChild(iframe);

    const doc = iframe.contentDocument || iframe.contentWindow.document;
    doc.open();
    doc.write(htmlContent);
    doc.close();

    // iframe.onload = () => {
    const images = iframe.contentDocument.images;
    const total = images?.length || 0;
    let loaded = 0;

    if (total === 0) {
      generatePDF();
    } else {
      for (let img of images) {
        img.onload = img.onerror = () => {
          loaded++;
          if (loaded === total) {
            generatePDF();
          }
        };
      }

      // setTimeout(() => {
      //   if (loaded < total) {
      //     generatePDF();
      //   }
      // }, imgDelay);
    }

    function generatePDF() {
      const defaultConfig = {
        margin: 0,
        filename: "template.pdf",
        image: { type: "jpeg", quality: 0.98 },
        html2canvas: {
          scale: 2,
          useCORS: true,
          scrollY: 0,
        },
        jsPDF: { unit: "mm", format: "a4", orientation: "portrait" }, // exact A4
        pagebreak: { mode: ["avoid-all", "css", "legacy"] },
      };

      const mergedConfig = {
        ...defaultConfig,
        ...config,
        image: { ...defaultConfig.image, ...(config.image || {}) },
        html2canvas: {
          ...defaultConfig.html2canvas,
          ...(config.html2canvas || {}),
        },
        jsPDF: { ...defaultConfig.jsPDF, ...(config.jsPDF || {}) },
        pagebreak: {
          ...defaultConfig.pagebreak,
          ...(config.pagebreak || {}),
        },
      };

      html2pdf()
        .from(iframe.contentDocument.body)
        .set(mergedConfig)
        .toContainer()
        .toCanvas()
        .toPdf()
        .get("pdf")
        .save()
        .then(() => {
          if (typeof onSuccess === "function") {
            onSuccess("PDF saved.");
          }
        })
        .catch((err) => {
          if (typeof onError === "function") {
            onError(err);
          }
        })
        .finally(() => {
          document.body.removeChild(iframe);
        });
    }
    // };
  } catch (error) {
    console.error("Error generating PDF:", error);
    if (typeof onError === "function") {
      onError(error);
    }
  } finally {
    console.log("Download function completed.");
  }
};
